import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SWOffering from "@/pages/SWOffering";

export const Route = createFileRoute("/en/services/software-solutions-services/data-integrity")({
  head: () => buildRouteHead("/en/services/software-solutions-services/data-integrity"),
  component: SWOffering,
});

